/**
 * PhoneFieldType — numer telefonu. Storage: PG VARCHAR(50).
 * MVP: bez parser/E.164 — tylko field input z auto-trim.
 */

import type { FieldInputProps, FieldTypeDefinition } from '../FieldRegistry';

function PhoneInput({ field, value, onChange, error, disabled, autoFocus }: FieldInputProps) {
  return (
    <input
      type="tel"
      value={typeof value === 'string' ? value : ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      autoFocus={autoFocus}
      placeholder="+48 123 456 789"
      aria-invalid={!!error}
      data-testid={`field-${field.slug}-input`}
      className="w-full rounded-md border border-border-primary bg-bg-primary px-3 py-2 text-sm text-text-primary placeholder-text-muted focus:border-accent-500 focus:outline-none focus:ring-1 focus:ring-accent-500 disabled:opacity-50"
    />
  );
}

export const PhoneFieldType: FieldTypeDefinition = {
  type: 'phone',
  renderInput: (props) => <PhoneInput {...props} />,
  renderCell: (_field, value) => (typeof value === 'string' ? value : ''),
  defaultValue: '',
};
